import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import ExclusiveStarIcon from '../common/ExclusiveStarIcon';

type Props = {
    icon: React.ReactNode;
    label: string;
    isExpanded: boolean;
    path: string;
    title: string;
    isPremiumFeature?: boolean;
}

const SideHeaderLink = ({ icon, label, isExpanded, path, title, isPremiumFeature = false }: Props) => {
    let location = useLocation()
    const [isSelected, setIsSelected] = React.useState(false);
    const { t } = useTranslation()
    const displayedLabel = useMemo(() => {
        return t(`${label}`)
    }, [label, t(`navigation`)])

    useEffect(() => {
        const isMatching = matchPath(path, location.pathname);
        setIsSelected(isMatching != null ? true : false);
    }, [location])

    function getSpanClassNames() {
        if (isExpanded) {
            return 'text-nowrap text-sm font-semibold';
        }
        return 'text-nowrap text-sm font-semibold hidden';
    }

    function getLinkColor() {
        if (isSelected) {
            return 'bg-utility-mutedLight text-primary-dark'
        }
        return 'bg-primary hover:bg-primary-light text-white'
    }

    function getLinkWidth() {
        if (isExpanded) {
            return 'w-full shadow-xl'
        }
        return 'w-full hover:w-max'
    }

    function getIconClass() {
        if (!isExpanded) {
            return "flex justify-center items-center w-full h-full"
        }
        return ""
    }

    const styledIcon = React.cloneElement(icon as any, {
        className: getIconClass(), // or any additional props you want to pass
        style: { fontSize: "30px" }
    });

    return (
        <Link to={path} className={`relative flex items-center border-solid border-[1px] border-primary space-x-2 z-20 py-[8px] px-[12px] w-full rounded-[8px] [&>span]:hover:inline transition-all ${getLinkColor()} ${getLinkWidth()}`} >
            <div className="flex items-center justify-center">
                {styledIcon}
            </div>
            <span className={getSpanClassNames()}>{displayedLabel}</span>
            {isPremiumFeature && (
                <ExclusiveStarIcon className={"absolute -top-3 -right-3 text-white"} />
            )}
        </Link>
    )
}

export default SideHeaderLink